/**
 * 全局路由映射表
 * 通过 routeKey 引用路由路径，避免在配置中硬编码路由字符串
 */

/** 全局路由 key 类型 */
export type RouteKey = string;

/** 全局路由映射表 */
export const routeMap: Record<RouteKey, string> = {
  // ====== 设置页 ======
  mineSetter: '/pages/mine/setter/index',
  mineAbout: '/pages/mine/setter/about/index',
  mineInfoList: '/pages/mine/setter/info-list/index',
  mineAccountInfo: '/pages/mine/account/index',
  mineShippingAddress: '/pages/mine/shipping-address/index',

  // ====== 个人中心 - 区域跳转 ======
  mineWallet: '/pages/mine/wallet/index',
  mineWalletRecharge: '/pages/mine/wallet/recharge',
  mineWalletWithdraw: '/pages/mine/wallet/withdraw',
  mineWalletBuyIntegral: '/pages/mine/wallet/buy-integral',
  mineWalletRecord: '/pages/mine/wallet/record',
  mineWalletIntegralOrder: '/pages/mine/wallet/integral-order',
  mineWalletIntegralFlow: '/pages/mine/wallet/integral-flow',
  mineWalletWithdrawAccount: '/pages/mine/wallet/withdraw-account',
  mineWalletWithdrawDetail: '/pages/mine/wallet/withdraw-detail',
  mineWalletWithdrawRecord: '/pages/mine/wallet/withdraw-record',
  mineOrderList: '/pages/order/list/list',
  mineWaitDeliveryOrderList: '/pages/order/list/waitDeliver',

  // ====== 个人中心 - 订单菜单 ======
  mineHistoryOrder: '/pages/order/list/history',
  historyOrder: '/pages/order/list/history',
  mineCoupon: '/pages/mine/coupon/index',
  mineCollectGoods: '/pages/mine/collect-goods/index',
  mineCollectShop: '/pages/mine/collect-shop/index',
  mineHistory: '/pages/mine/history/index',

  // ====== 个人中心 - 常用功能 ======
  mineOrderConfig: '/pages/order/config/index',
  mineDropshipping: '/pages/platform/index',
  mineTagManage: '/pages/mine/brand/index',
  mineUploadManager: '/pages/platform/upload-manager/index',
  mineSellersDiscount: '/pages/mine/sellers-discount/index',
  mineCloudGoods: '/pages/mine/cloud-goods/cloud-goods',
  mineLackGoodsList: '/pages/order/lack/lack',
  mineRefundList: '/pages/mine/refund-list/refund-list',
  mineOrderRedress: '/pages/order/redress/redress',
  mineReturnSendBack: '/pages/mine/return-send-back/return-send-back',
  mineReturnStocking: '/pages/mine/return-stocking',
  mineReturnAddress: '/pages/mine/return-address/index',
  mineAppDownload: '/pages/common/appDownload/appDownloadH5',

  // ====== 上传记录 ======
  mineUploadRecordDetail: '/pages/mine/upload/record/details/details',

  // ====== 售后任务 ======
  afterSaleTask: '/pages/order/refund/task/index',
  afterSaleTaskDetail: '/pages/order/refund/task/details/index',
  afterSaleTaskApply: '/pages/order/refund/task/apply/index',

  // ====== 个人中心 - 我的服务 ======
  mineShop: '/pages-seller/home/index',
  myCloudWarehouse: '/pages/mine/cloudWarehouse/index',
  cloudStall: '/pages/cloud/stall/index',
  cloudStallFundsRecord: '/pages/cloud/funds-record/index',
  cloudStallInventory: '/pages/cloud/stall/inventory-store-manage/index',
  cloudStallOutBound: '/pages/cloud/stall/inventory-out-bound/index',
  cloudStallOutBoundDetail: '/pages/cloud/stall/inventory-out-bound/detail',
  cloudStallOutBoundApply: '/pages/cloud/stall/inventory-out-bound/apply',
  cloudStallEnterBound: '/pages/cloud/stall/inventory-enter-bound/index',
  cloudStallEnterBoundDetail: '/pages/cloud/stall/inventory-enter-bound/detail',
  cloudStallEnterBoundApply: '/pages/cloud/stall/inventory-enter-bound/apply',
  cloudStallSnList: '/pages/cloud/stall/sn-list/index',
  cloudStallLackStats: '/pages/cloud/stall/lack-stats/index',
  cloudStallRestockStats: '/pages/cloud/stall/restock-stats/index',
  mineFactory: '/pages/mine/factory',
  mineLease: '/pages/mine/lease',

  // ====== 档口列表 ======
  shopList: '/pages/shop/list/list',
  shopListHighQuality: '/pages/shop/list/list?type=1',

  // ====== 商品详情 ======
  goodsDetails: '/pages/goods/details/details',

  // ====== 商品列表 ======
  goodsList: '/pages/goods/list/list',
  giftList: '/pages/goods/list/gift',

  // ====== 吊牌物料 ======
  brandApplyList: '/pages/mine/brand/apply-list/index',
  brandApply: '/pages/mine/brand/apply/index',
  brandAddStock: '/pages/mine/brand/apply/index',

  // ====== 代采订单 ======
  proxyPurchaseIndex: '/pages/order/proxyPurchase/index',
  proxyPurchaseCreate: '/pages/order/proxyPurchase/create',
  proxyPurchaseCart: '/pages/order/proxyPurchase/cart',
  proxyPurchaseDetail: '/pages/order/proxyPurchase/detail',

  // ====== 平台店铺/订单 ======
  platformShop: '/pages/platform/shop-list/index',
};

/**
 * 解析路由 key 为完整 URL（含查询参数）
 * @param key 路由标识
 * @param params 额外查询参数，会追加到路由后面
 */
export function resolveRoute(key: RouteKey, params?: Record<string, any>): string {
  const route = routeMap[key];
  if (!route) return '';

  if (!params) return route;

  const queryStr = Object.entries(params)
    .map(([k, v]) => `${k}=${v}`)
    .join('&');
  return queryStr ? `${route}?${queryStr}` : route;
}

/**
 * 通过路由 key 执行页面跳转
 * @param key 路由标识
 * @param params 额外查询参数
 */
export function navigateByKey(key: RouteKey, params?: Record<string, any>) {
  const url = resolveRoute(key, params);
  if (!url) return;
  uni.navigateTo({ url });
}

export function redirectByKey(key: RouteKey, params?: Record<string, any>) {
  const url = resolveRoute(key, params);
  if (!url) return;
  uni.redirectTo({ url });
}
